import { z } from 'zod';

export const MaterialFormulaSchema = z.object({
  mfid: z.number(),
  mfmid: z.number(),
  mfname: z.string(),
  mfformula: z.string()
});

export type MaterialFormula = z.infer<typeof MaterialFormulaSchema>; 